import { sendRequestAuto } from '@/utils/request'

export type PaymentEndpoint = 'qpay' | 'storepay' | 'pocket' | 'lend' | 'omniway'

export const checkPaymentApi = (url: string) => sendRequestAuto({ url })

export const checkOrderPaymentApi = (method: PaymentEndpoint, orderId: string, vendorId: string) =>
  checkPaymentApi(`/order/payment/${method}/${orderId}/vendor/${vendorId}`)

export const checkGiftCardPaymentApi = (giftCardId: string, vendorId: string) =>
  checkPaymentApi(`/order/payment/qpay/giftcard/${giftCardId}/vendor/${vendorId}`)

/*
  Split payment: mint an invoice for whatever is still owed on an order.

  Posted anonymously with the Vendor header, like checkout itself — the customer paying
  a balance days after the deposit is usually a guest on /order/{customId}/{phone} with
  no session. Ownership is proved by the customId + phone pair in the path, and the
  backend rate-limits this route because that pair is guessable.
*/
export const createBalanceInvoiceApi = (customId: string, phone: string, vendorId: string, method: PaymentEndpoint) =>
  sendRequestAuto({
    url: `/order/custom/${customId}/phone/${phone}/balance`,
    method: 'POST',
    body: { method },
    headers: { Vendor: vendorId },
  })
